import { isDev, post } from '@chat/utils';
import React, { lazy } from 'react';
import { CONFIG } from '@/api/url';

export const getBaseUrl = () => {
    return '/chat/im';
};

export const PAGE_CODE = {
    SUCCESS: 0,
    NO_FOUND: 404,
    NO_START: 300,
    ENDED: 301,
    CLOSED: 302,
    NO_VIP: 400
};
// 获取游戏配置
export const getConfigData = (key) => {
    const { platform } = IM.SDKServer.getState();
    return post(CONFIG(key), { platform });
};

// 间隔时间
export const TIME_OUT = 180000;
// 消息字数限制
export const WORD_LIMIT = 500;
// 编辑器图片数量限制
export const MAX_IMAGE_COUNT = 10;
// FAQ 图文请求体编码后大小限制
export const FAQ_REQUEST_BODY_LIMIT = 40 * 1024 * 1024;

// 弹窗
const D_end = lazy(() => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_end'));
const D_closeWebView = lazy(
    () => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_closeWebView')
);
const D_contact = lazy(
    () => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_contact')
);
const D_notice = lazy(
    () => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_notice')
);
const D_evaluate = lazy(
    () => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_evaluate')
);
const D_comment = lazy(
    () => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_comment')
);
const D_video = lazy(() => import(/* webpackChunkName: "dialog" */ '@/components/Dialog/D_video'));
export const dialogMaps = [
    { name: 'end', Components: D_end },
    { name: 'closeWebView', Components: D_closeWebView },
    { name: 'contact', Components: D_contact },
    { name: 'notice', Components: D_notice },
    { name: 'evaluate', Components: D_evaluate },
    { name: 'comment', Components: D_comment },
    { name: 'video', Components: D_video }
];

export const sensitiveWords = ['投诉', '报警'];
export const sensitiveReg = /投诉|报警/;
export const stars = [
    { star: 1, txt: '非常不满意' },
    { star: 2, txt: '不满意' },
    { star: 3, txt: '一般' },
    { star: 4, txt: '满意' },
    { star: 5, txt: '非常满意' }
];
export const ctxRcForm = React.createContext(null);

export const defaultVariables = {
    base: {
        '--bg-loading': 'rgba(255, 255, 255, 0.4)',
        // PC大背景
        '--bg': `url('${isDev ? '' : getBaseUrl()}/assets/bg.jpg')`,
        // 聊天主体背景
        '--bg-mask': '#fff',
        // 按钮默认色
        '--bg-defaultbtn': '#f4f4f4',
        // 内容
        '--bg-content': '#f4f4f4',
        // 内容（亮色）
        '--bg-contentlight': '#eeeeee',
        // 内容（深色）
        '--bg-contentdeep': '#e7e7e7',
        // 聊天输入框
        '--bg-textarea': '#fff',
        // 警告通知
        '--bg-warning': '#e6e6e6',
        // 错误通知
        '--bg-error': '#f3dddd',
        // 信息通知
        '--bg-info': '#e0f0fc',
        // 弹窗遮罩
        '--bg-dark': 'rgba(0, 0, 0, 0.4)',
        // 顶部导航
        '--bg-nav': 'linear-gradient(#ffffff, #f4f4f4)',

        // 主题色
        '--color-primary': '#3597e3',
        // 主题色（深色）
        '--color-primarydeep': '#2f88cc',
        // 黑色
        '--color-dark': '#000000',
        // 白色
        '--color-white': '#fff',
        // placholder
        '--color-placeholder': '#a2a2a2',
        // 用户名称
        '--color-user': '#333333',
        // 全局默认色
        '--color-default': '#565656',
        // 按钮默认色
        '--color-defaultbtn': '#999999',
        // 错误
        '--color-error': '#e55656',
        // 边框
        '--color-border': '#cccccc',
        // 禁用
        '--color-disable': '#cccccc',
        // 分割线
        '--color-divider': '#e8e7e7',
        // 客服链接颜色
        '--color-link-gm': '#3597e3',
        // 用户链接颜色
        '--color-link-im': '#fff',
        // shadow
        '--color-shadow': '#d7d7d7'
    },
    vip: {
        '--bg-loading': 'rgba(255, 255, 255, 0.4)',
        // PC大背景
        '--bg': `url('${isDev ? '' : getBaseUrl()}/assets/bg-vip.jpg')`,
        // 聊天主体背景
        '--bg-mask': '#fff',
        // 按钮默认色
        '--bg-defaultbtn': '#f4f4f4',
        // 内容
        '--bg-content': '#f4f4f4',
        // 内容（亮色）
        '--bg-contentlight': '#eeeeee',
        // 内容（深色）
        '--bg-contentdeep': '#e7e7e7',
        // 聊天输入框
        '--bg-textarea': '#fff',
        // 警告通知
        '--bg-warning': '#e6e6e6',
        // 错误通知
        '--bg-error': '#f3dddd',
        // 信息通知
        '--bg-info': '#fdf1e6',
        // 弹窗遮罩
        '--bg-dark': 'rgba(0, 0, 0, 0.4)',
        // 顶部导航
        '--bg-nav': 'linear-gradient(#ffffff, #f4f4f4)',

        // 主题色
        '--color-primary': '#bf8a55',
        // 主题色（深色）
        '--color-primarydeep': '#9c6a37',
        // 黑色
        '--color-dark': '#000000',
        // 白色
        '--color-white': '#fff',
        // placholder
        '--color-placeholder': '#a2a2a2',
        // 用户名称
        '--color-user': '#333333',
        // 全局默认色
        '--color-default': '#565656',
        // 按钮默认色
        '--color-defaultbtn': '#999999',
        // 错误
        '--color-error': '#e55656',
        // 边框
        '--color-border': '#cccccc',
        // 禁用
        '--color-disable': '#cccccc',
        // 分割线
        '--color-divider': '#e8e7e7',
        // 客服链接颜色
        '--color-link-gm': '#9c6a37',
        // 用户链接颜色
        '--color-link-im': '#fff',
        // shadow
        '--color-shadow': '#d7d7d7',

        // vip 专属
        '--gradient-primary': 'linear-gradient(90deg, #c59b70, #dbb48f)',
        '--gradient-primarydeep': 'linear-gradient(90deg, #b7865b, #d2a179)'
    }
};
export const imageTypes = ['.jpg', '.jpeg', '.png', '.gif'];
export const videoTypes = [
    '.mp4',
    '.avi',
    '.flv',
    '.asf',
    '.mov',
    '.mpeg',
    '.wmv',
    '.rm',
    '.rmvb',
    '.mpg',
    '.3gp',
    '.m4v',
    '.mkv'
];

export const DIFY_REQUEST_TIMEOUT = 30 * 1000;
export const pubKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAznth4fnAggT3BCJiVUOh
HOOvz07Vge8WZWH/PT1VSdYZa/P5yy4/8bizl2CnvPmkPBnnd32TaTUHjgXqnwsW
sVq7uGHez44himcRStEYaRxBrdgthrD4nScKTfk5GsCqPln7VbtIviHeo90unzZm
40SY/85TdMZMkFcpfPu3w+s+7W+crYn1v9vh4hVSozau/dDQb5QAs+cMEPTZgmNA
PPddF09ObwuyOlX3G/77/q/1tdJ5Cqhz52q1x2qZAHT0Xx1MVgOP/LCsAszflLIO
D9TOeCWga2fKxAoLy0y3mla1vuuTsGyueq6Mnm2bceQsbL8pE7bkbMkiLesbaMbH
dQIDAQAB
-----END PUBLIC KEY-----`;
